<div class="row w-100" *ngIf="title && title === 'administration'">
  <div class="col-md-4">
    <img
      src="/assets/images/RespondEDU-Logo-Colored.svg"
      alt="logo-img"
      height="100"
      width="200"
      style="border-radius: 50%"
      *ngIf="!isTeacherOnly"
    />
    <img src="/assets/images/Teacher-only-color-logo.svg" alt="logo-img" height="100" width="150" *ngIf="isTeacherOnly" />
  </div>
  <div class="col-md-4 d-flex justify-content-center">
    <div class="w-100">
      <ngx-form-stepper></ngx-form-stepper>
    </div>
  </div>
  <div class="col-md-4"></div>
</div>

<div
  [ngClass]="{
    'dark-theme': alayticsService.currentTheme === 'material-dark'
  }"
>
  <ngx-spinner
    template="<img src='/assets/icons/Respond-spinner.gif' height='170' width='170' class='text-center' loading='lazy'/>"
    [showSpinner]="loading"
    size="small"
    [disableAnimation]="false"
    color="white"
    bdColor="rgba(0,0,0,0.5)"
    [fullScreen]="isTeacherOnly ? 'true' : 'false'"
    [zIndex]="1003"
  >
  </ngx-spinner>

  <div class="col-md-12">
    <nb-card class="mt-3 academic-info-card-content">
      <nb-card-header style="background-color: #d1e9ff">
        <div class="info-label pt-2">
          <label style="color: #175cd3" class="personal-info quicksand-bold-label info-label" *ngIf="title && title !== 'administration'"
            >Teacher Academic Information</label
          >
          <h6 class="personal-info quicksand-bold-label info-label" *ngIf="title && title === 'administration'" style="color: #175cd3">
            Teacher Academic Information
          </h6>
        </div>
      </nb-card-header>

      <nb-card-body>
        <div class="info-label pt-2">
          <span
            *ngIf="title && (title === 'administration' || title === 'teacherNewAcademicYearSetup')"
            class="quicksand-normal-label administration-info-label"
            >(This data will be used in generating pacing plans for your classes. You will not be able to modify this information after this
            screen)</span
          >
          <form [formGroup]="teachingInfoForm">
            <!-- <div
              class="form-group row"
              *ngIf="title && title === 'administration'"
            >
              <div class="col-md-6">
                <label
                  class="label form-control-label label-dark-mode-color dark-label"
                  ><span *ngIf="title === 'administration'"
                    >Please select your designation
                    <span class="required-field">*</span></span
                  >
                </label>
              </div>

              <div class="col-md-5">
                <nb-radio-group
                  class="d-flex bell-schedule-radio"
                  (valueChange)="setDesignation($event)"
                  formControlName="designation"
                  name="designation-radio-group"
                  [disabled]="user?.is_trial_user"
                >
                  <nb-radio value="Elementary"> Elementary Teacher </nb-radio>
                  <nb-radio value="Highschool" style="margin-left: 3rem">
                    6th-12th grade Teacher
                  </nb-radio>
                </nb-radio-group>
              </div>
            </div> -->

            <div class="form-group row d-flex align-items-center">
              <div class="col-md-6">
                <label class="label form-control-label dark-label"
                  ><span *ngIf="title === 'administration' || title === 'teacherNewAcademicYearSetup'"
                    >Which subjects do you teach? <span class="required-field">*</span></span
                  >
                  <span *ngIf="title !== 'administration' && title !== 'teacherNewAcademicYearSetup'">Subjects You Teach</span>
                </label>
              </div>

              <div class="col-md-6">
                <nb-select
                  class="w-100 profile input-color select-subject"
                  multiple
                  placeholder="Select Subject"
                  formControlName="teachingSubject"
                  (selectedChange)="setSubjectCount($event)"
                  [disabled]="user?.is_trial_user"
                >
                  <nb-option *ngFor="let subject of subjects" [value]="subject.id" [ngClass]="{ 'disable-option': localStorageUserData?.role_id === 19 }">{{ subject.subject }}</nb-option>
                </nb-select>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-6">
                <label class="label form-control-label label-dark-mode-color dark-label"
                  ><span *ngIf="title === 'administration' || title === 'teacherNewAcademicYearSetup'"
                    >What grades do you teach? <span class="required-field">*</span></span
                  >
                  <span *ngIf="title !== 'administration' && title !== 'teacherNewAcademicYearSetup'">Grades You Teach</span>
                </label>
              </div>

              <div class="col-md-6">
                <!-- [disabled]="!teachingInfoForm.value.designation" -->
                <nb-select
                  placeholder="Select Grade"
                  class="profile input-color"
                  multiple
                  fullWidth
                  *ngIf="!user?.is_trial_user"
                  formControlName="teachingGrades"
                >
                  <nb-option class="input-color" *ngFor="let grade of grades" [value]="grade.id" [ngClass]="{ 'disable-option': localStorageUserData?.role_id === 19 }">{{ grade.grade }}</nb-option>
                </nb-select>

                <nb-select
                  placeholder="Select Grade"
                  class="profile input-color"
                  multiple
                  fullWidth
                  formControlName="teachingGrades"
                  *ngIf="user?.is_trial_user"
                  [disabled]="user?.is_trial_user"
                >
                  <nb-option class="input-color" *ngFor="let grade of grades" [value]="grade.id" [ngClass]="{ 'disable-option': localStorageUserData?.role_id === 19 }">{{ grade.grade }}</nb-option>
                </nb-select>
              </div>
            </div>

            <div
              class="form-group row"
              *ngIf="title && (title === 'administration' || title === 'teacherNewAcademicYearSetup') && !isTeacherOnly"
            >
              <div class="col-md-6">
                <label class="label form-control-label label-dark-mode-color dark-label"
                  ><span *ngIf="title === 'administration' || title === 'teacherNewAcademicYearSetup'"
                    >Will you utilize the School's Bell Schedule? <span class="required-field">*</span></span
                  >
                </label>
                <br />
                <label class="bell-shedule-label quicksand-normal-label">
                  Your administrator has created the school bell schedule with the weekly periods. If you are not going to follow the shared
                  bell schedule, you must create your personalized schedule by selecting no below.
                </label>
              </div>

              <div class="col-md-6">
                <nb-radio-group
                  name="bell-shedule-radio-group"
                  formControlName="bellShedule"
                  class="d-flex bell-schedule-radio"
                  [disabled]="user?.is_trial_user"
                >
                  <nb-radio value="true"> Yes </nb-radio>
                  <nb-radio value="false"> No </nb-radio>
                </nb-radio-group>
              </div>
            </div>
          </form>
          <div class="submit-info text-right pt-3" *ngIf="localStorageUserData?.role_id !== 19">
            <button
              nbButton
              color="warn"
              class="save-changes-btn quicksand-bold-label"
              (click)="openConfirmationDialog()"
              [disabled]="teachingInfoForm.invalid"
            >
              Save Changes
            </button>
          </div>
        </div>
      </nb-card-body>
    </nb-card>
  </div>
</div>
